// extracted by mini-css-extract-plugin
module.exports = {"xviaBannerContainer":"banner_xviaBannerContainer__21JMu","xviaBanner":"banner_xviaBanner__3mnjb","xviaBannerContent":"banner_xviaBannerContent__29OBH"};